import {isValidEmail} from '@Utils/string.util';
import {TagInputType} from '@Components/tags-input-field/tags-input-field.types';

export const isInvalidTagInput = (inputValue: string, tagInputType: TagInputType): boolean => {
  if (tagInputType === TagInputType.EMAIL) {
    return inputValue.length > 0 && !isValidEmail(inputValue);
  }
  return false;
};